//@ts-check
import React from 'react';
import store from '../../../store';
import ACTIONS from '../../../store/actions';
import PublicLink from '../../../apps/PublicLink';
import loadManifest from '../../../apps/manifest/loadManifest';
import loadUserInfo from './loadUserInfo';
import useProvider from '../useProvider';
import queryString from 'query-string';

var disableInitialRequests = function disableInitialRequests(routes) {
  if (!routes) return false;
  if (!routes.history) return false;
  var location = routes.location || routes.history.location;
  if (!location) return false;

  var _queryString$parse = queryString.parse(location.search),
      embed = _queryString$parse.embed; // if an embed route need initial requests
  // either use another path OR
  // implement a `disableInitialRequests` parameter on EcrionProvider.routes
  //  and set it to "auto" by default to preserve backward compatibility


  var isEmbed = location.pathname.startsWith('/embed');
  if (isEmbed || embed) return true;
  return false;
};

var startedRequest = false;

var useInitialRequests = function useInitialRequests() {
  var _useProvider = useProvider(),
      microservice = _useProvider.microservice,
      routes = _useProvider.routes;

  var _PublicLink$usePublic = PublicLink.usePublicLink(),
      publicId = _PublicLink$usePublic.publicId;

  var appId = microservice && microservice.id;
  React.useEffect(function () {
    if (publicId) {
      store.dispatch({
        type: ACTIONS.USER_INFO_GET_RESOLVED,
        payload: {
          userName: 'Public',
          // email: 'public.user@example.com',
          // environmentName: '',
          permissions: [],
          firstName: 'Public',
          lastName: 'User'
        }
      });
      return;
    }

    if (disableInitialRequests(routes)) return;
    if (startedRequest) return;
    store.dispatch(loadManifest({
      microservice: appId
    }));
    store.dispatch(loadUserInfo({
      microservice: appId,
      routes: routes
    }));
    startedRequest = true;
  }, [publicId, appId, routes]);
};

export default (function () {
  useInitialRequests();
  return null;
});